/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Explore_MethodInputs */

const en_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the Egly Method`)
};

const es_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar el método Egly`)
};

const de_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken Sie die Egly-Methode`)
};

const zh_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索 Egly Method`)
};

const ar_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشف منهج Egly`)
};

const fr_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorez la méthode Egly`)
};

const vi_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khám phá Phương pháp Egly`)
};

const sw_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunguza Mbinu ya Egly`)
};

const th_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำรวจวิธีการของ Egly`)
};

const bs_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istražite Egly metodu`)
};

const ja_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Methodを見る`)
};

const ko_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly 메서드 둘러보기`)
};

const pt_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore o Egly Method`)
};

const it_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri l’Egly Method`)
};

const sv_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforska Egly Method`)
};

const nl_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verken de Egly Method`)
};

const da_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udforsk Egly Method`)
};

const nb_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforsk Egly Method`)
};

const fi_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutustu Egly Methodiin`)
};

const pl_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznaj Egly Method`)
};

const ru_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Узнайте об Egly Method`)
};

const tr_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method'i keşfedin`)
};

const hi_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method का अन्वेषण करें`)
};

const id_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi Metode Egly`)
};

const ms_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terokai Egly Method`)
};

const cs_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozkoumejte metodu Egly`)
};

const el_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εξερευνήστε τη Μέθοδο Egly`)
};

const he_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עקבו אחרי Egly Method`)
};

const af_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verken die Egly-metode`)
};

const hu_about_explore_method = /** @type {(inputs: About_Explore_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fedezze fel az Egly Method`)
};

/**
* | output |
* | --- |
* | "Explore the Egly Method" |
*
* @param {About_Explore_MethodInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_explore_method = /** @type {((inputs?: About_Explore_MethodInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Explore_MethodInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_explore_method(inputs)
	if (locale === "de") return de_about_explore_method(inputs)
	if (locale === "zh") return zh_about_explore_method(inputs)
	if (locale === "ar") return ar_about_explore_method(inputs)
	if (locale === "fr") return fr_about_explore_method(inputs)
	if (locale === "vi") return vi_about_explore_method(inputs)
	if (locale === "sw") return sw_about_explore_method(inputs)
	if (locale === "th") return th_about_explore_method(inputs)
	if (locale === "bs") return bs_about_explore_method(inputs)
	if (locale === "ja") return ja_about_explore_method(inputs)
	if (locale === "ko") return ko_about_explore_method(inputs)
	if (locale === "pt") return pt_about_explore_method(inputs)
	if (locale === "it") return it_about_explore_method(inputs)
	if (locale === "sv") return sv_about_explore_method(inputs)
	if (locale === "nl") return nl_about_explore_method(inputs)
	if (locale === "da") return da_about_explore_method(inputs)
	if (locale === "nb") return nb_about_explore_method(inputs)
	if (locale === "fi") return fi_about_explore_method(inputs)
	if (locale === "pl") return pl_about_explore_method(inputs)
	if (locale === "ru") return ru_about_explore_method(inputs)
	if (locale === "tr") return tr_about_explore_method(inputs)
	if (locale === "hi") return hi_about_explore_method(inputs)
	if (locale === "id") return id_about_explore_method(inputs)
	if (locale === "ms") return ms_about_explore_method(inputs)
	if (locale === "cs") return cs_about_explore_method(inputs)
	if (locale === "el") return el_about_explore_method(inputs)
	if (locale === "he") return he_about_explore_method(inputs)
	if (locale === "af") return af_about_explore_method(inputs)
	if (locale === "hu") return hu_about_explore_method(inputs)
	return en_about_explore_method(inputs)
});